import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { startAuthFlow } from '@chegg-wt/core/state/user/actions'
import { AuthPayload } from '@chegg-wt/core/types/auth'
import { AuthModalOrigin } from '../AuthModal/types'
import * as Styled from '../styled'
import { MODAL_CONTENT, MODAL_WRAPPER } from '../testIds'
import { CitationLimit, CreateAccount, CreateAccountMessage } from './styled'
import { CITATION_LIMIT_HEADING, CREATE_ACCOUNT_BTN, CREATE_ACCOUNT_MSG } from './testIds'

export interface ValueExchangeModalProps {
  createAccountCTA: (data: AuthPayload) => void
}

export const ValueExchangeModal: React.FunctionComponent<ValueExchangeModalProps> = ({
  createAccountCTA,
}) => {
  const heading = `You've hit your citation limit.`
  const message = 'Create a free account to make unlimited citations.'
  const buttonText = 'Create a free account'

  const handleCreateAccount = () => {
    createAccountCTA({
      defaultFlow: 'signup',
      origin: AuthModalOrigin.CITATION_FORM_PAGE,
    } as AuthPayload)
  }

  return (
    <Styled.ModalWrapper
      backdrop
      show
      enableScroll={false}
      renderBackdrop={() => <Styled.DefaultBackdrop />}
      data-test={MODAL_WRAPPER}
    >
      <Styled.PositioningWrapper>
        <Styled.ModalContent fullMobileModal data-test={MODAL_CONTENT} maxWidth="430px">
          <Styled.Container>
            <CitationLimit data-test={CITATION_LIMIT_HEADING}>{heading}</CitationLimit>
            <CreateAccountMessage data-test={CREATE_ACCOUNT_MSG}>
              {message}
            </CreateAccountMessage>
            <CreateAccount onClick={handleCreateAccount} data-test={CREATE_ACCOUNT_BTN}>
              {buttonText}
            </CreateAccount>
          </Styled.Container>
        </Styled.ModalContent>
      </Styled.PositioningWrapper>
    </Styled.ModalWrapper>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createAccountCTA: (data: AuthPayload) => {
    dispatch(
      startAuthFlow({
        defaultFlow: data.defaultFlow,
        origin: data.origin,
        alwaysParticipate: data.alwaysParticipate,
        redirectTo: data.redirectTo,
      })
    )
  },
})

export default connect(null, mapDispatchToProps)(ValueExchangeModal)
